angular.module("ainapp")
    .controller("ProjectWiseProfitController", ["$scope", "app.config", "$http", "$state", "AuthenticationService", "MainService",
        function ($scope, config, $http, $state, AuthenticationService, MainService) {


            $scope.PageName = "Project Wise Profit";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.CostCentersList = [];
            MainService.GetAllCostcentersInJobReprot().then(function (response) {
                $scope.CostCentersList = response.data;
            });

            $scope.Init = function () {

                $scope.isLoadReport = false;
                $scope.ViewVal = 0;

                $scope.date1 = new Date();
                var n = $scope.date1.getFullYear();
                $scope.d2 = new Date("01/01/" + n);

                $scope.filter = {
                    Level: 0,
                    FromDate: $scope.d2,
                    ToDate: new Date(),
                }

                $scope.finyear = {};
                MainService.getCurrentFinancialYear().then(function (response) {
                    $scope.finyear = response.data;
                    $scope.filter.FromDate = new Date($scope.finyear.StartDate);
                });

                $scope.CostCenters = [];
                MainService.GetJobCostCenters().then(function (response) {
                    $scope.CostCenters = response.data;
                });

                $('#filterModal').modal('show');

            }
            $scope.Init();


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($scope.isLoadReport) {

                            o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                            o.data.FromDay = $scope.filter.FromDate.getDate();
                            o.data.FromYear = $scope.filter.FromDate.getFullYear();

                            o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                            o.data.ToDay = $scope.filter.ToDate.getDate();
                            o.data.ToYear = $scope.filter.ToDate.getFullYear();

                            o.data.JobNos = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                if (e.IsSelected) {
                                    o.data.JobNos.push(e.Name);
                                }
                            })

                            o.data.CostCenterList = [];
                            angular.forEach($scope.CostCentersList, function (e) {
                                if (e.SelectedCostCenterId > 0) {
                                    o.data.CostCenterList.push(e.SelectedCostCenterId);
                                }
                            })


                            MainService.JobWiseProfitSummary(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            JobNo: {
                                type: "string",
                                editable: false
                            },
                            Date: {
                                type: "date",
                                editable: false
                            },
                            "AccountName": {
                                type: "string",
                                editable: false
                            },
                            SINVGross: {
                                type: "number",
                                editable: false
                            },
                            PINVGross: {
                                type: "number",
                                editable: false
                            },
                            PINVFreightCharges: {
                                type: "number",
                                editable: false
                            },
                            PINVPackingCharges: {
                                type: "number",
                                editable: false
                            },
                            IPINVClearingCharges: {
                                type: "number",
                                editable: false
                            },
                            IPINVDutyCharges: {
                                type: "number",
                                editable: false
                            },
                            IPINVFreightharges: {
                                type: "number",
                                editable: false
                            },
                            IPINVOtherharges: {
                                type: "number",
                                editable: false
                            },
                            ReceiptCommission: {
                                type: "number",
                                editable: false
                            },
                            ExpenseAmount: {
                                type: "number",
                                editable: false
                            },
                            ProfitLossValue: {
                                type: "number",
                                editable: false
                            },
                            StockIssueCharges: {
                                type: "number",
                                editable: false
                            },
                            ProfitPer: {
                                type: "number",
                                editable: false
                            }

                        }
                    }
                },

                aggregate: [
                    {
                        field: "SINVGross",
                        aggregate: "sum"
                                },
                    {
                        field: "PINVGross",
                        aggregate: "sum"
                                },
                    {
                        field: "PINVFreightCharges",
                        aggregate: "sum"
                                },
                    {
                        field: "PINVPackingCharges",
                        aggregate: "sum"
                                },
                    {
                        field: "IPINVClearingCharges",
                        aggregate: "sum"
                                },
                    {
                        field: "IPINVDutyCharges",
                        aggregate: "sum"
                                },
                    {
                        field: "IPINVFreightharges",
                        aggregate: "sum"
                                },
                    {
                        field: "IPINVOtherharges",
                        aggregate: "sum"
                                },
                    {
                        field: "ReceiptCommission",
                        aggregate: "sum"
                                },
                    {
                        field: "ExpenseAmount",
                        aggregate: "sum"
                                },
                    {
                        field: "ProfitLossValue",
                        aggregate: "sum"
                                }, {
                        field: "StockIssueCharges",
                        aggregate: "sum"
                                }
                            ],
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "JobNo",
                        title: "Job No",
                            },
                    {
                        field: "AccountName",
                        title: "Customer",
                            },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                            },
                    {
                        field: "SINVGross",
                        title: "Sales Invoice Gross",
                        template: "<div style='text-align: right'>#=kendo.toString(SINVGross, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "PINVGross",
                        title: "Purchase Invoice Gross",
                        template: "<div style='text-align: right'>#=kendo.toString(PINVGross, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "PINVFreightCharges",
                        title: "Freight Charges",
                        template: "<div style='text-align: right'>#=kendo.toString(PINVFreightCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "PINVPackingCharges",
                        title: "Packing Charges",
                        template: "<div style='text-align: right'>#=kendo.toString(PINVPackingCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "IPINVClearingCharges",
                        title: "Import Clearing Charges",
                        template: "<div style='text-align: right'>#=kendo.toString(IPINVClearingCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "IPINVDutyCharges",
                        title: "Import Duty Charges",
                        template: "<div style='text-align: right'>#=kendo.toString(IPINVDutyCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "IPINVFreightharges",
                        title: "Import Freight Charges",
                        template: "<div style='text-align: right'>#=kendo.toString(IPINVFreightharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "IPINVOtherharges",
                        title: "Import Other Charges",
                        template: "<div style='text-align: right'>#=kendo.toString(IPINVOtherharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            }, {
                        field: "StockIssueCharges",
                        title: "Stock Issue Charges",
                        template: "<div style='text-align: right'>#=kendo.toString(StockIssueCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "ReceiptCommission",
                        title: "Receipt Commission Charges",
                        template: "<div style='text-align: right'>#=kendo.toString(ReceiptCommission, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "ExpenseAmount",
                        title: "Expenses",
                        template: "<div style='text-align: right'>#=kendo.toString(ExpenseAmount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "ProfitLossValue",
                        title: "Profit / Loss",
                        template: "<div style='text-align: right'>#=kendo.toString(ProfitLossValue, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                            },
                    {
                        field: "ProfitPer",
                        title: "Profit %",
                        template: "<div style='text-align: right'>#=kendo.toString(ProfitPer, 'n')#</div>",
                            },
                    {
                        field: "",
                        width: "200px",
                        title: "Cost Centers",
                        template: "<span ng-repeat='cc in dataItem.JobWiseProfitDetails'> <span ng-repeat='jp in cc.JobwiseProfitCosts'> {{jp.CostCenterName}} * </span> </span>"
                            },
                    ],
            };



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isLoadReport = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                $('#filterModal').modal('hide');
            }


        }]);
